import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import emptyDashboard from '../../assets/images/empty-dashboard.svg';
import { genericTexts, titles } from '@utils/translations/en';

type EmptyDashboardProps = {
  all?: boolean;
};

const EmptyDashboard: FC<EmptyDashboardProps> = ({ all = false }) => (
  <Box
    sx={{
      height: '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}
  >
    <img
      src={emptyDashboard}
      alt={titles.PVX_PARTNERS}
      style={{
        width: '150px',
        height: 'auto',
        marginBottom: 20,
      }}
    />
    <Typography
      sx={{
        fontSize: '1.25rem',
        fontWeight: '700',
        marginBottom: 1,
      }}
    >
      {all ? genericTexts.noDashboardAccess : genericTexts.noDashboardAccessForModule}
    </Typography>
    <span
      style={{
        fontSize: '0.875rem',
        color: '#6B7280',
        fontWeight: '500',
      }}
    >
      {genericTexts.reachOutAdmin1}
      <a href="mailto:info@pvxpartners.com" style={{ color: '#51B8B0' }}>
        {genericTexts.administrator}
      </a>
      {genericTexts.reachOutAdmin2}
    </span>
  </Box>
);

export default EmptyDashboard;
